//one scanned carton = one T_Tally record. The same barcode can be scanned repeatedly
//(a label identifies the product, not a unique carton), so each scan gets its own id.
export interface TallyRecord {
  id: string;
  tallySerialNo: string;
  tallyQty: number; //weight read from the GS1 barcode
  tallyEffect: string; //'S' = Stock
  tallyEffectQty: number; //mirrors tallyQty
  useByDate?: string; //yyyy-mm-dd
  mfgDate?: string; //yyyy-mm-dd
  gtin?: string;
  batch?: string;
  //filled in from the pallet's T_Serial record after the use-by lookup
  serialNo?: string;
  binNo?: string;
  locationNo?: string;
  //set when the scanned use-by did not match T_Serial.UseByDate for this pallet
  useByMismatch?: boolean;
  scannedAt: string;
}

export const tallyEffectStock = "S";
